import PropTypes from 'prop-types';
import React from 'react';

import { createBEM } from '../../../../lib/utils/css';

import './RowItemBadges.scss';

const RowItemBadges = React.memo(({ isInteractive, children, isFullRowLink }) => {
  const classNames = createBEM('RowItemBadges', {
    hidden: isInteractive,
    fullRowLink: isFullRowLink,
  });

  return <div className={classNames}>{children}</div>;
});

RowItemBadges.propTypes = {
  children: PropTypes.node.isRequired,
  isInteractive: PropTypes.bool.isRequired,
  isFullRowLink: PropTypes.bool.isRequired,
};

export default RowItemBadges;
